<template>
  <v-form
   
    ref='exposuresForm'>
    <v-card
      v-for="(exposure, i) in user.health.exposures"
      v-bind:key="i"
      class=condCard>
      <v-combobox
        v-model="user.health.exposures[i].name"
        :items="exposureList"
        class="inline"
        color="blue-grey lighten-2"
        label="Select from dropdown or type in a custom response.">
      </v-combobox>

      <v-text-field
        v-model="exposure.start"
        label="When did you start to consume/use this substance"></v-text-field>

      <div>
        Do you still use this substance?
        <v-radio-group
          v-model="exposure.currentUser"
          true-value="true"
          false-value="false">
          <v-radio
            label="Yes"
            :value="true"></v-radio>
          <v-radio
            label="No"
            :value="false"></v-radio>
        </v-radio-group>
      </div>

      <v-text-field
        v-show="user.health.exposures[i].currentUser === false"
        v-model="exposure.stop"
        label="When did you stop consuming/using this substance"></v-text-field>

      <v-text-field
        v-model="exposure.usePerWeek"
        label="How many times a week do/did you consume/use this substance"></v-text-field>

      <v-textarea
        v-model="exposure.details"
        label="Please add any extra details about this substance."></v-textarea>

      <v-btn
        right
        depressed
        class="right white--text"
        color="red"
        @click="remove(exposure)">
        Remove
      </v-btn>
    </v-card>
    <center>
      <v-btn
        class="padded white--text"
        color="green"
        @click="addCond">
        Add Substance
      </v-btn>
    </center>
  </v-form>
</template>


<script>
import { mapFields } from "vuex-map-fields";
import DateQuest from "./DateQuest"
export default {
  components: {
    DateQuest
  },
  props: {
  },
  mounted () {
    this.exposureList.sort()
  },
  methods: {
    remove (item) {
      const index = this.user.health.exposures.indexOf(item);
      if (index >= 0)
        this.user.health.exposures.splice(index, 1);
    },
    addCond() {
      var exposure = {
        name: '',
        currentUser: '',
        start: '',
        stop:'',
        usePerWeek: '',
        details: ''
      };
      this.user.health.exposures.push(exposure);
    }
  },
  data () {
    return {

    };
  },
  computed: {
    ...mapFields("patientQuestion", [
      "dataModel",
      "exposures",
   
      "exposureList"
    ]),
    ...mapFields([
      "user"
    ])
  }
};
</script>
<style>
.condCard {
  padding: 20px;
  margin: 5px;
}
.padded {
  margin: 5px 5px 5px 5px;
}
</style>
